<template>
  <b-modal
    id="connection-lost-modal"
    ref="connectionLostModal"
    modal-class="delete-modal"
    size="sm">
    <div class="text-center">
      <h5>Your connection has been lost. Please refresh your page.</h5>
    </div>
    <template slot="modal-footer">
      <b-button
        @click="reloadPage">
        Refresh
      </b-button>
      <b-button @click="hide">
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: 'ConnectionLostModal',
  methods: {
    reloadPage() {
      window.location.reload();
    },
    show() {
      this.$refs.connectionLostModal.show();
    },
    hide() {
      this.$refs.connectionLostModal.hide();
    },
  },
};
</script>
